<template>
  <div>
    <ConfigFinanceMain />
  </div>
</template>

<script>
import ConfigFinanceMain from "../components/config/ConfigFinanceMain.vue";

export default {
  name: "ConfigFinanceView",
  components: { ConfigFinanceMain },
};
</script>
